export default "__VITE_ASSET__tCiAPHvI__"